import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/course/base"

const course = {
  courseListPage(pageSize, limit, keyWord, classId, subjectId, typeId, bookId, sortId) {
    return axios.get(pre + `/courseListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          classId: classId,
          subjectId: subjectId,
          typeId: typeId,
          bookId: bookId,
          sortId: sortId
        }
    });
  }
  ,
  courseInfo(id) {
    return axios.get(pre + `/courseInfo`, {params: {id: id}});
  }
  ,
  courseSave(params) {
    return axios.post(pre + `/courseSave`, qs.stringify(params));
  }
  ,
  courseDelete(id) {
    return axios.delete(pre + `/courseDelete`, {params: {id: id}});
  }
  ,
}
export default course;



// WEBPACK FOOTER //
// ./src/api/course/course.js